import { Outlet } from 'react-router-dom';
import { useDisableChatPageZoom } from '@/hooks/useDisableChatPageZoom';

/** Contenedor a altura completa entre cabecera de app y tab bar (lista o hilo). */
export function ChatsLayout() {
  useDisableChatPageZoom();

  return (
    <div className="chats-layout">
      <Outlet />
    </div>
  );
}
